// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../../../node_modules/react-perfect-scrollbar/dist/css/styles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --font-family-primary: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}

* {
  font-family: var(--font-family-primary);
}

html, body {
  font-family: var(--font-family-primary);
}

h1, h2, h3, h4, h5, h6,
p, span, div, a, button, input, textarea, select, label {
  font-family: var(--font-family-primary);
}

.MuiTypography-root,
.MuiButton-root,
.MuiTextField-root,
.MuiInputBase-root,
.MuiFormLabel-root,
.MuiChip-root,
.MuiTableCell-root,
.MuiTableHead-root,
.MuiTableRow-root {
  font-family: var(--font-family-primary) !important;
}

.MuiButtonBase-root,
.MuiIconButton-root,
.MuiFab-root,
.MuiCard-root,
.MuiCardContent-root,
.MuiCardHeader-root,
.MuiDialog-root,
.MuiDialogTitle-root,
.MuiDialogContent-root,
.MuiDialogActions-root,
.MuiMenu-root,
.MuiMenuItem-root,
.MuiList-root,
.MuiListItem-root,
.MuiListItemText-root,
.MuiListItemIcon-root,
.MuiAppBar-root,
.MuiToolbar-root,
.MuiDrawer-root,
.MuiPaper-root,
.MuiContainer-root,
.MuiBox-root,
.MuiGrid-root,
.MuiStack-root,
.MuiAlert-root,
.MuiSnackbar-root,
.MuiTooltip-root,
.MuiPopover-root,
.MuiAutocomplete-root,
.MuiSelect-root,
.MuiCheckbox-root,
.MuiRadio-root,
.MuiSwitch-root,
.MuiSlider-root,
.MuiRating-root,
.MuiTabs-root,
.MuiTab-root,
.MuiStepLabel-root,
.MuiStepContent-root,
.MuiStepConnector-root,
.MuiBreadcrumbs-root,
.MuiPagination-root,
.MuiTablePagination-root,
.MuiAccordion-root,
.MuiAccordionSummary-root,
.MuiAccordionDetails-root,
.MuiSpeedDial-root,
.MuiSpeedDialAction-root,
.MuiTimeline-root,
.MuiTimelineItem-root,
.MuiTimelineContent-root,
.MuiTimelineSeparator-root,
.MuiTimelineConnector-root,
.MuiTimelineDot-root,
.MuiSkeleton-root,
.MuiLinearProgress-root,
.MuiCircularProgress-root,
.MuiBackdrop-root,
.MuiModal-root,
.MuiFade-root,
.MuiGrow-root,
.MuiSlide-root,
.MuiZoom-root,
.MuiCollapse-root,
.MuiExpansionPanel-root,
.MuiExpansionPanelSummary-root,
.MuiExpansionPanelDetails-root {
  font-family: var(--font-family-primary) !important;
}

.fullscreen .react-images__blanket {
  z-index: 1200;
}

.apexcharts-legend-series .apexcharts-legend-marker {
  margin-right: 8px;
}

.scrollbar-container .ps__rail-y:hover > .ps__thumb-y, .scrollbar-container .ps__rail-y:focus > .ps__thumb-y, .scrollbar-container .ps__rail-y.ps--clicking .ps__thumb-y {
  background-color: #697586;
  width: 5px;
}
.scrollbar-container .ps__thumb-y {
  background-color: #697586;
  border-radius: 6px;
  width: 5px;
  right: 0;
}

.scrollbar-container.ps.ps--active-y > .ps__rail-y,
.scrollbar-container > .ps.ps--active-y > .ps__rail-y {
  width: 5px;
  background-color: transparent !important;
  z-index: 999;
}
.scrollbar-container.ps.ps--active-y > .ps__rail-y:hover, .scrollbar-container.ps.ps--active-y > .ps__rail-y.ps--clicking,
.scrollbar-container > .ps.ps--active-y > .ps__rail-y:hover,
.scrollbar-container > .ps.ps--active-y > .ps__rail-y.ps--clicking {
  width: 5px;
  background-color: transparent;
}
.scrollbar-container.ps.ps--scrolling-y > .ps__rail-y, .scrollbar-container.ps.ps--scrolling-x > .ps__rail-x,
.scrollbar-container > .ps.ps--scrolling-y > .ps__rail-y,
.scrollbar-container > .ps.ps--scrolling-x > .ps__rail-x {
  opacity: 0.4;
  background-color: transparent;
}

@keyframes wings {
  50% {
    transform: translateY(-40px);
  }
  100% {
    transform: translateY(0px);
  }
}
@keyframes blink {
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes bounce {
  0%, 20%, 53%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  40%, 43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -5px, 0);
  }
  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -7px, 0);
  }
  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translateZ(0);
  }
  90% {
    transform: translate3d(0, -2px, 0);
  }
}
@keyframes slideY {
  0%, 50%, 100% {
    transform: translateY(0px);
  }
  25% {
    transform: translateY(-10px);
  }
  75% {
    transform: translateY(10px);
  }
}
@keyframes slideX {
  0%, 50%, 100% {
    transform: translateX(0px);
  }
  25% {
    transform: translateX(-10px);
  }
  75% {
    transform: translateX(10px);
  }
}
.font-test {
  font-family: var(--font-family-primary) !important;
  font-weight: 400;
}

.font-test-bold {
  font-family: var(--font-family-primary) !important;
  font-weight: 700;
}

body *,
body *::before,
body *::after {
  font-family: var(--font-family-primary) !important;
}

@media (max-width: 600px) {
  .MuiContainer-root {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    max-width: 100% !important;
    box-sizing: border-box;
  }
  html, body {
    overflow-x: hidden !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/style.scss","webpack://./src/assets/scss/_themes-vars.module.scss"],"names":[],"mappings":"AAOA;EACE;kFAAA;AAgDF;;AA5CA;EACE,uCAAA;AA+CF;;AA5CA;EACE,uCAAA;AA+CF;;AA3CA;;EAEE,uCAAA;AA8CF;;AA1CA;;;;;;;;;EASE,kDAAA;AA6CF;;AAzCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmEE,kDAAA;AA4CF;;AAxCA;EACE,aAAA;AA2CF;;AAtCA;EACE,iBAAA;AAyCF;;AAlCI;EAGE,yBCrFI;EDsFJ,UAAA;AAmCN;AAhCE;EACE,yBC1FM;ED2FN,kBAAA;EACA,UAAA;EACA,QAAA;AAkCJ;;AA5BE;;EACE,UAAA;EACA,wCAAA;EACA,YAAA;AAgCJ;AA/BI;;;EAEE,UAAA;EACA,6BAAA;AAkCN;AA/BE;;;EAEE,YAAA;EACA,6BAAA;AAkCJ;;AA5BA;EACE;IACE,4BAAA;EA+BF;EA7BA;IACE,0BAAA;EA+BF;AACF;AA5BA;EACE;IACE,UAAA;EA8BF;EA5BA;IACE,UAAA;EA8BF;AACF;AA3BA;EACE;IAIE,8DAAA;IACA,wBAAA;EA0BF;EAxBA;IAEE,iEAAA;IACA,kCAAA;EAyBF;EAvBA;IACE,iEAAA;IACA,kCAAA;EAyBF;EAvBA;IACE,+DAAA;IACA,wBAAA;EAyBF;EAvBA;IACE,kCAAA;EAyBF;AACF;AAtBA;EACE;IAGE,0BAAA;EAsBF;EApBA;IACE,4BAAA;EAsBF;EApBA;IACE,2BAAA;EAsBF;AACF;AAnBA;EACE;IAGE,0BAAA;EAmBF;EAjBA;IACE,4BAAA;EAmBF;EAjBA;IACE,2BAAA;EAmBF;AACF;AAfA;EACE,kDAAA;EACA,gBAAA;AAiBF;;AAdA;EACE,kDAAA;EACA,gBAAA;AAiBF;;AAbA;;;EAGE,kDAAA;AAgBF;;AAZA;EACE;IACE,0BAAA;IACA,2BAAA;IACA,yBAAA;IACA,0BAAA;IACA,0BAAA;IACA,sBAAA;EAeF;EAbA;IACE,6BAAA;EAeF;AACF","sourcesContent":["// color variants\r\n@import 'themes-vars.module.scss';\r\n\r\n// third-party\r\n@import '~react-perfect-scrollbar/dist/css/styles.css';\r\n\r\n// ==============================|| GLOBAL STYLES ||============================== //\r\n:root {\r\n  --font-family-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\r\n}\r\n\r\n* {\r\n  font-family: var(--font-family-primary);\r\n}\r\n\r\nhtml, body {\r\n  font-family: var(--font-family-primary);\r\n}\r\n\r\n// Ensure all text elements use Inter font\r\nh1, h2, h3, h4, h5, h6,\r\np, span, div, a, button, input, textarea, select, label {\r\n  font-family: var(--font-family-primary);\r\n}\r\n\r\n// Material-UI component font override\r\n.MuiTypography-root,\r\n.MuiButton-root,\r\n.MuiTextField-root,\r\n.MuiInputBase-root,\r\n.MuiFormLabel-root,\r\n.MuiChip-root,\r\n.MuiTableCell-root,\r\n.MuiTableHead-root,\r\n.MuiTableRow-root {\r\n  font-family: var(--font-family-primary) !important;\r\n}\r\n\r\n// Additional Material-UI component overrides for better coverage\r\n.MuiButtonBase-root,\r\n.MuiIconButton-root,\r\n.MuiFab-root,\r\n.MuiCard-root,\r\n.MuiCardContent-root,\r\n.MuiCardHeader-root,\r\n.MuiDialog-root,\r\n.MuiDialogTitle-root,\r\n.MuiDialogContent-root,\r\n.MuiDialogActions-root,\r\n.MuiMenu-root,\r\n.MuiMenuItem-root,\r\n.MuiList-root,\r\n.MuiListItem-root,\r\n.MuiListItemText-root,\r\n.MuiListItemIcon-root,\r\n.MuiAppBar-root,\r\n.MuiToolbar-root,\r\n.MuiDrawer-root,\r\n.MuiPaper-root,\r\n.MuiContainer-root,\r\n.MuiBox-root,\r\n.MuiGrid-root,\r\n.MuiStack-root,\r\n.MuiAlert-root,\r\n.MuiSnackbar-root,\r\n.MuiTooltip-root,\r\n.MuiPopover-root,\r\n.MuiAutocomplete-root,\r\n.MuiSelect-root,\r\n.MuiCheckbox-root,\r\n.MuiRadio-root,\r\n.MuiSwitch-root,\r\n.MuiSlider-root,\r\n.MuiRating-root,\r\n.MuiTabs-root,\r\n.MuiTab-root,\r\n.MuiStepLabel-root,\r\n.MuiStepContent-root,\r\n.MuiStepConnector-root,\r\n.MuiBreadcrumbs-root,\r\n.MuiPagination-root,\r\n.MuiTablePagination-root,\r\n.MuiAccordion-root,\r\n.MuiAccordionSummary-root,\r\n.MuiAccordionDetails-root,\r\n.MuiSpeedDial-root,\r\n.MuiSpeedDialAction-root,\r\n.MuiTimeline-root,\r\n.MuiTimelineItem-root,\r\n.MuiTimelineContent-root,\r\n.MuiTimelineSeparator-root,\r\n.MuiTimelineConnector-root,\r\n.MuiTimelineDot-root,\r\n.MuiSkeleton-root,\r\n.MuiLinearProgress-root,\r\n.MuiCircularProgress-root,\r\n.MuiBackdrop-root,\r\n.MuiModal-root,\r\n.MuiFade-root,\r\n.MuiGrow-root,\r\n.MuiSlide-root,\r\n.MuiZoom-root,\r\n.MuiCollapse-root,\r\n.MuiExpansionPanel-root,\r\n.MuiExpansionPanelSummary-root,\r\n.MuiExpansionPanelDetails-root {\r\n  font-family: var(--font-family-primary) !important;\r\n}\r\n\r\n// ==============================|| LIGHT BOX ||============================== //\r\n.fullscreen .react-images__blanket {\r\n  z-index: 1200;\r\n}\r\n\r\n// ==============================|| APEXCHART ||============================== //\r\n\r\n.apexcharts-legend-series .apexcharts-legend-marker {\r\n  margin-right: 8px;\r\n}\r\n\r\n// ==============================|| PERFECT SCROLLBAR ||============================== //\r\n\r\n.scrollbar-container {\r\n  .ps__rail-y {\r\n    &:hover > .ps__thumb-y,\r\n    &:focus > .ps__thumb-y,\r\n    &.ps--clicking .ps__thumb-y {\r\n      background-color: $grey500;\r\n      width: 5px;\r\n    }\r\n  }\r\n  .ps__thumb-y {\r\n    background-color: $grey500;\r\n    border-radius: 6px;\r\n    width: 5px;\r\n    right: 0;\r\n  }\r\n}\r\n\r\n.scrollbar-container.ps,\r\n.scrollbar-container > .ps {\r\n  &.ps--active-y > .ps__rail-y {\r\n    width: 5px;\r\n    background-color: transparent !important;\r\n    z-index: 999;\r\n    &:hover,\r\n    &.ps--clicking {\r\n      width: 5px;\r\n      background-color: transparent;\r\n    }\r\n  }\r\n  &.ps--scrolling-y > .ps__rail-y,\r\n  &.ps--scrolling-x > .ps__rail-x {\r\n    opacity: 0.4;\r\n    background-color: transparent;\r\n  }\r\n}\r\n\r\n// ==============================|| ANIMATION KEYFRAMES ||============================== //\r\n\r\n@keyframes wings {\r\n  50% {\r\n    transform: translateY(-40px);\r\n  }\r\n  100% {\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@keyframes blink {\r\n  50% {\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes bounce {\r\n  0%,\r\n  20%,\r\n  53%,\r\n  to {\r\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    transform: translateZ(0);\r\n  }\r\n  40%,\r\n  43% {\r\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n    transform: translate3d(0, -5px, 0);\r\n  }\r\n  70% {\r\n    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);\r\n    transform: translate3d(0, -7px, 0);\r\n  }\r\n  80% {\r\n    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    transform: translateZ(0);\r\n  }\r\n  90% {\r\n    transform: translate3d(0, -2px, 0);\r\n  }\r\n}\r\n\r\n@keyframes slideY {\r\n  0%,\r\n  50%,\r\n  100% {\r\n    transform: translateY(0px);\r\n  }\r\n  25% {\r\n    transform: translateY(-10px);\r\n  }\r\n  75% {\r\n    transform: translateY(10px);\r\n  }\r\n}\r\n\r\n@keyframes slideX {\r\n  0%,\r\n  50%,\r\n  100% {\r\n    transform: translateX(0px);\r\n  }\r\n  25% {\r\n    transform: translateX(-10px);\r\n  }\r\n  75% {\r\n    transform: translateX(10px);\r\n  }\r\n}\r\n\r\n// ==============================|| FONT TEST ||============================== //\r\n.font-test {\r\n  font-family: var(--font-family-primary) !important;\r\n  font-weight: 400;\r\n}\r\n\r\n.font-test-bold {\r\n  font-family: var(--font-family-primary) !important;\r\n  font-weight: 700;\r\n}\r\n\r\n// Force Inter font on all elements with higher specificity\r\nbody *,\r\nbody *::before,\r\nbody *::after {\r\n  font-family: var(--font-family-primary) !important;\r\n}\r\n\r\n// Mobile fixes: remove left-only whitespace from Containers and prevent horizontal overflow\r\n@media (max-width: 600px) {\r\n  .MuiContainer-root {\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n    max-width: 100% !important;\r\n    box-sizing: border-box;\r\n  }\r\n  html, body {\r\n    overflow-x: hidden !important;\r\n  }\r\n}\r\n","// paper & background\r\n$paper: #ffffff;\r\n\r\n// primary\r\n$primaryLight: #eef2f6;\r\n$primaryMain: #2196f3;\r\n$primaryDark: #1e88e5;\r\n$primary200: #90caf9;\r\n$primary800: #1565c0;\r\n\r\n// secondary\r\n$secondaryLight: #ede7f6;\r\n$secondaryMain: #673ab7;\r\n$secondaryDark: #5e35b1;\r\n$secondary200: #b39ddb;\r\n$secondary800: #4527a0;\r\n\r\n// success Colors\r\n$successLight: #b9f6ca;\r\n$success200: #69f0ae;\r\n$successMain: #00e676;\r\n$successDark: #00c853;\r\n\r\n// error\r\n$errorLight: #ef9a9a;\r\n$errorMain: #f44336;\r\n$errorDark: #c62828;\r\n\r\n// orange\r\n$orangeLight: #fbe9e7;\r\n$orangeMain: #ffab91;\r\n$orangeDark: #d84315;\r\n\r\n// warning\r\n$warningLight: #fff8e1;\r\n$warningMain: #ffe57f;\r\n$warningDark: #ffc107;\r\n\r\n// grey\r\n$grey50: #f8fafc;\r\n$grey100: #eef2f6;\r\n$grey200: #e3e8ef;\r\n$grey300: #cdd5df;\r\n$grey500: #697586;\r\n$grey600: #4b5565;\r\n$grey700: #364152;\r\n$grey900: #121926;\r\n\r\n// ==============================|| DARK THEME VARIANTS ||============================== //\r\n\r\n// paper & background\r\n$darkBackground: #1a223f; // level 3\r\n$darkPaper: #111936; // level 4\r\n\r\n// dark 800 & 900\r\n$darkLevel1: #29314f; // level 1\r\n$darkLevel2: #212946; // level 2\r\n\r\n// primary dark\r\n$darkPrimaryLight: #eef2f6;\r\n$darkPrimaryMain: #2196f3;\r\n$darkPrimaryDark: #1e88e5;\r\n$darkPrimary200: #90caf9;\r\n$darkPrimary800: #1565c0;\r\n\r\n// secondary dark\r\n$darkSecondaryLight: #d1c4e9;\r\n$darkSecondaryMain: #7c4dff;\r\n$darkSecondaryDark: #651fff;\r\n$darkSecondary200: #b39ddb;\r\n$darkSecondary800: #6200ea;\r\n\r\n// text variants\r\n$darkTextTitle: #d7dcec;\r\n$darkTextPrimary: #bdc8f0;\r\n$darkTextSecondary: #8492c4;\r\n\r\n// ==============================|| JAVASCRIPT ||============================== //\r\n\r\n:export {\r\n  // paper & background\r\n  paper: $paper;\r\n\r\n  // primary\r\n  primaryLight: $primaryLight;\r\n  primary200: $primary200;\r\n  primaryMain: $primaryMain;\r\n  primaryDark: $primaryDark;\r\n  primary800: $primary800;\r\n\r\n  // secondary\r\n  secondaryLight: $secondaryLight;\r\n  secondary200: $secondary200;\r\n  secondaryMain: $secondaryMain;\r\n  secondaryDark: $secondaryDark;\r\n  secondary800: $secondary800;\r\n\r\n  // success\r\n  successLight: $successLight;\r\n  success200: $success200;\r\n  successMain: $successMain;\r\n  successDark: $successDark;\r\n\r\n  // error\r\n  errorLight: $errorLight;\r\n  errorMain: $errorMain;\r\n  errorDark: $errorDark;\r\n\r\n  // orange\r\n  orangeLight: $orangeLight;\r\n  orangeMain: $orangeMain;\r\n  orangeDark: $orangeDark;\r\n\r\n  // warning\r\n  warningLight: $warningLight;\r\n  warningMain: $warningMain;\r\n  warningDark: $warningDark;\r\n\r\n  // grey\r\n  grey50: $grey50;\r\n  grey100: $grey100;\r\n  grey200: $grey200;\r\n  grey300: $grey300;\r\n  grey500: $grey500;\r\n  grey600: $grey600;\r\n  grey700: $grey700;\r\n  grey900: $grey900;\r\n\r\n  // ==============================|| DARK THEME VARIANTS ||============================== //\r\n\r\n  // paper & background\r\n  darkPaper: $darkPaper;\r\n  darkBackground: $darkBackground;\r\n\r\n  // dark 800 & 900\r\n  darkLevel1: $darkLevel1;\r\n  darkLevel2: $darkLevel2;\r\n\r\n  // text variants\r\n  darkTextTitle: $darkTextTitle;\r\n  darkTextPrimary: $darkTextPrimary;\r\n  darkTextSecondary: $darkTextSecondary;\r\n\r\n  // primary dark\r\n  darkPrimaryLight: $darkPrimaryLight;\r\n  darkPrimaryMain: $darkPrimaryMain;\r\n  darkPrimaryDark: $darkPrimaryDark;\r\n  darkPrimary200: $darkPrimary200;\r\n  darkPrimary800: $darkPrimary800;\r\n\r\n  // secondary dark\r\n  darkSecondaryLight: $darkSecondaryLight;\r\n  darkSecondaryMain: $darkSecondaryMain;\r\n  darkSecondaryDark: $darkSecondaryDark;\r\n  darkSecondary200: $darkSecondary200;\r\n  darkSecondary800: $darkSecondary800;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `#ffffff`,
	"primaryLight": `#eef2f6`,
	"primary200": `#90caf9`,
	"primaryMain": `#2196f3`,
	"primaryDark": `#1e88e5`,
	"primary800": `#1565c0`,
	"secondaryLight": `#ede7f6`,
	"secondary200": `#b39ddb`,
	"secondaryMain": `#673ab7`,
	"secondaryDark": `#5e35b1`,
	"secondary800": `#4527a0`,
	"successLight": `#b9f6ca`,
	"success200": `#69f0ae`,
	"successMain": `#00e676`,
	"successDark": `#00c853`,
	"errorLight": `#ef9a9a`,
	"errorMain": `#f44336`,
	"errorDark": `#c62828`,
	"orangeLight": `#fbe9e7`,
	"orangeMain": `#ffab91`,
	"orangeDark": `#d84315`,
	"warningLight": `#fff8e1`,
	"warningMain": `#ffe57f`,
	"warningDark": `#ffc107`,
	"grey50": `#f8fafc`,
	"grey100": `#eef2f6`,
	"grey200": `#e3e8ef`,
	"grey300": `#cdd5df`,
	"grey500": `#697586`,
	"grey600": `#4b5565`,
	"grey700": `#364152`,
	"grey900": `#121926`,
	"darkPaper": `#111936`,
	"darkBackground": `#1a223f`,
	"darkLevel1": `#29314f`,
	"darkLevel2": `#212946`,
	"darkTextTitle": `#d7dcec`,
	"darkTextPrimary": `#bdc8f0`,
	"darkTextSecondary": `#8492c4`,
	"darkPrimaryLight": `#eef2f6`,
	"darkPrimaryMain": `#2196f3`,
	"darkPrimaryDark": `#1e88e5`,
	"darkPrimary200": `#90caf9`,
	"darkPrimary800": `#1565c0`,
	"darkSecondaryLight": `#d1c4e9`,
	"darkSecondaryMain": `#7c4dff`,
	"darkSecondaryDark": `#651fff`,
	"darkSecondary200": `#b39ddb`,
	"darkSecondary800": `#6200ea`
};
export default ___CSS_LOADER_EXPORT___;
